import { FieldAPI, FileUploaderAPI } from '@philips-emr/tws-components';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import { Endpoints } from '../definitions/endpoints';

interface API {
  field: FieldAPI;
  fileUploader: FileUploaderAPI;
}

class FileService {

  static setPredefinedFiles(funcionalidade: number, apiFileUploader: API): void {
    HttpService.get<[]>(Endpoints.GET.PREDEFINED_FILES, { funcionalidade })
      .then(({ body }) => {
        if (body) {
          const predefinedFiles = body.map(regras => {
            const { dsLabelCampo: value, nrSeqRegraAnexo: key, ieObrigatorio } = regras;
            const required = ieObrigatorio === 'S';
            return { key: String(key), value, ...(required && { required: String(required) }) };
          });

          if (!predefinedFiles.length) {
            apiFileUploader.field.setVisible(false);
          } else {
            apiFileUploader.fileUploader.setPredefinedFiles(predefinedFiles);
          }
        }
      })
      .catch(() => apiFileUploader.field.setVisible(false));
  }
}

export {
  FileService,
};
